import { render, staticRenderFns } from "./DomainMenu.vue?vue&type=template&id=3ee6f443&"
import script from "./DomainMenu.vue?vue&type=script&lang=js&"
export * from "./DomainMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports